import ticketsTemplate from './tickets.template.html';

/*****************************************************************************
 * Component: tickets */
/**
 * @ngdoc     component
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.component:tickets
 * @description
 * This component handles the "Tickets" tab content in the AddChangeEventDialog
 * component. It displays the list of available products and those that have been
 * added to the event as tickets. Using the ShuttleService, products can be
 * dragged/moved between lists.
 *****************************************************************************/
export const ticketsComponent = {
  require: { dialogCtrl: '^^addChangeEventDialog' },
  template: ticketsTemplate,
  controller: 'TicketsCtrl'
}

/*****************************************************************************
 * Controller: TicketsCtrl */
/**
 * @ngdoc     controller
 * @module    csm.books.eventsAdmin
 * @methodof  csm.books.eventsAdmin.controller:tickets
 * @description
 * Controller for the `tickets` component.
 *****************************************************************************/
/* @ngInject */ export function TicketsController($injector, $scope, ShuttleService) {
  var $ctrl = this;

  /*----------------------------------------------------*/
  /* Register the event handler for the ShuttleService. */
  /*----------------------------------------------------*/
  ShuttleService.group('products').cmdHandler = $injector.invoke(
    cmdHandler,
    null,
    { $ctrl: $ctrl }
  );
}

/***************************************************************************
 * cmdHandler */
/**
 * @ngdoc     controller
 * @module    csm.books.eventsAdmin
 * @methodof  csm.books.eventsAdmin.controller:tickets
 * @param  cmd     Shuttle command object.
 * @param  source  Source shuttle-list controller.
 * @param  target  Target shuttle-list controller.
 * @description
 * Shuttle service handler to manage moving items between available products
 * and current tickets.
 ***************************************************************************/
/* @ngInject */ function cmdHandler($ctrl) {
  return function (cmd, source, target) {
    /*------------------------------------*/
    /* Prevent changes in read only mode. */
    /*------------------------------------*/
    if ($ctrl.dialogCtrl.readOnlyMode) return;

    /*----------------------------------------------*/
    /* Source and target IDs are different. Product */
    /* is being moved from one list to another.     */
    /*----------------------------------------------*/
    if (source.id != target.id) {
      if (cmd.click) return cmd.handler.shuttleItem();

      if (
        (cmd.right && source.id == 'available-groups') ||
        (cmd.left && source.id == 'selected-groups')
      )
        return cmd.ctrlKey
          ? cmd.handler.shuttleItem()
          : cmd.handler.shuttleFocus(0);
    }

    if (cmd.dragStart) return cmd.handler.startDrag('move');
    if (cmd.dragOver) return cmd.handler.allowDrop('move');
    if (cmd.dragEnter) return !!cmd.dropElement.addClass('insert');

    if (cmd.dragLeave || cmd.drop) {
      cmd.dropElement.removeClass('insert');

      if (cmd.drop) cmd.handler.drop(-1);
      return true;
    }
  };
}
